<template>

    <div>

        <env-label />

        <main-header />

        <!--@todo zone-->
        <!--        <div class="bg-warning p-2">
                    <div class="container">
                        <div class="text-center">
                            +++ <a href="/haendler/pluradent" class="link-dark fw-bold">Pluradent</a> Systemumstellung - Keine taggleiche Auslieferung möglich +++
                        </div>
                    </div>
                </div>-->

        <info-bar v-if="$page.props.app.theme == 'dentagen'" />

        <main class="main">
            <messages />
            <slot />
        </main>

        <main-footer />

        <!-- @todo <offcanvas-cart />-->

        <modal />
        <support />

    </div>

</template>

<script>
    import Messages from '@/shared/Messages';
    import OffcanvasCart from '@/shared/OffcanvasCart';
    import Modal from '@/shared/Modal';
    import Support from '@/shared/Support';
    import EnvLabel from '@/shared/EnvLabel';
    import InfoBar from '@/shared/InfoBar';
    import MainHeader from '@/shared/MainHeader';
    import MainFooter from '@/shared/MainFooter';

    export default {
        props: {
        },
        mounted() {
            // @fixme event handler irgendwann nicht mehr aktiv
            var menuDropdown = this.$refs.menuDropdown;
            if (menuDropdown) {
                menuDropdown.addEventListener('shown.bs.dropdown', function () {
                    console.log('Menu opened.');
                    document.body.classList.add('menu-open');
                });
                menuDropdown.addEventListener('hidden.bs.dropdown', function () {
                    console.log('Menu closed.');
                    document.body.classList.remove('menu-open');
                });

                // @todo click -> event.stopPropagation();
            }
        },
        data() {
            return {
            }
        },
        components: {
            Messages,
            OffcanvasCart,
            Modal,
            Support,
            EnvLabel,
            InfoBar,
            MainHeader,
            MainFooter,
        },
        watch: {
        },
    }
</script>